import { StrictMode } from 'react'
import { ErrorBoundary } from '@sentry/react'

import { ErrorFallback } from 'pages/ErrorFallback'

import { Router } from './Router'
import { Providers } from './providers'

export const Bootstrap = () => (
  <StrictMode>
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Providers>
        <Router />
      </Providers>
    </ErrorBoundary>
  </StrictMode>
)
